import * as i0 from "@angular/core";
export class ModalService {
    constructor() { }
    setModal(modal) {
        this.yourModal = modal;
    }
    showModal() {
        this.yourModal.show();
    }
}
ModalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModalService_Factory() { return new ModalService(); }, token: ModalService, providedIn: "root" });
